import {
  Component,
  OnInit,
  Optional,
  Inject,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { MessageService } from 'src/app/common/services/message.service';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { ApiService } from '../../services/api.service';
import { CurrencyService } from 'src/app/util/currency.service';
import { TranslateService } from '@ngx-translate/core';
import { FormaterService } from '../../services/formater.service';
import { LanguageService } from '../../services/language.service';
import { country } from '../../enums/language';
import { CROSS } from 'src/defaultImages.js';
import { UtilService } from 'src/app/util/util.service';
import { LocalStorageService } from '../../services/localStorage.service';
import { EasyEatHqService } from '../../services/ee-hq.service';
@Component({
  selector: 'app-add-discount',
  templateUrl: './add-discount.component.html',
  styleUrls: ['./add-discount.component.css'],
})
export class AddDiscountComponent implements OnInit {
  payAtKiosk;
  images = { 
    CROSS: CROSS,
  }
  Currency;
  tabsGroup = [
    { label: 'CLIENT COUPON', value: 'client_coupon' },
    { label: 'PRESETS', value: 'presets' },
    { label: 'FLAT CASH DISCOUNT', value: 'flat' },
    { label: 'PERCENTAGE DISCOUNT', value: 'percentage' },
  ];
  reasonPresets = [
    { label: 'Celebrations', value: 'celebrations' },
    { label: 'Discount to Staff', value: 'discount_to_staff' },
    { label: 'Loyal Customer', value: 'loyal_customer' },
    { label: 'Issue with Food/Service', value: 'issue_with_food_service' },
    // { label: "Other Reason", value: "other_reason" },
  ];
  allPresetCouponsList: any = [];
  presetCouponList: any = [];
  percentageDiscount;
  flatDiscount;
  flatTopup;
  customDiscountValue: string = '';
  selectedAmount: string = '';
  currentTab: string = 'presets';
  customDiscount: any;
  selectedReason: string;
  selectedDiscount: string;
  isLoading: boolean = false;
  searchFilter: string = '';
  customReason: string = '';
  modalTexts: any;
  translationText;
  isPresetEnabled: boolean = false;
  isSpecialPreset: number | null = null;
  isUserDetailsSet: number = 0;
  nric: string | null = null;
  @ViewChild('customInput', { static: false }) customInput: ElementRef;
  isHQUser: boolean = false;
  isClientCouponEnabled: boolean = false;
  clientCouponCode: string = '';
  listOfClientCoupons: any = [];


  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<any>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private messageService: MessageService,
    private apiService: ApiService,
    private curr: CurrencyService,
    public translateService: TranslateService,
    public format: FormaterService,
    private _lang: LanguageService,
    private _util : UtilService,
    private _localStorage: LocalStorageService,
    private _hqService: EasyEatHqService
  ) {
    this.customDiscount = (this.data || {}).customDiscount;
    this.payAtKiosk = this._util.payAtKiosk()
    this.Currency = this.curr.getCurrency();
    this.initialiseProperty();

    try {
      if (this.customDiscount) {
        if (this.customDiscount.custom_percentage_list) {
          this.percentageDiscount = this.customDiscount.custom_percentage_list;
        }
        if (this.customDiscount.custom_flat_list) {
          this.flatDiscount = this.customDiscount.custom_flat_list;
        }
        if (this.customDiscount.custom_flatTopup_list) {
          this.flatTopup = this.customDiscount.custom_flatTopup_list;
        }
      }
    } catch (error) {}

    this.isPresetEnabled = !!((JSON.parse(
      localStorage.getItem('restaurant_settings')
    ) || {})['discount'] || {})['preset'];

    this.isUserDetailsSet =
      JSON.parse(this._localStorage.get('pos_no_enter')) ||
      this.data?.isUserDetailsSet ||
      0;

    this.nric =
      this._localStorage.get('pos_unique_id') || this.data?.nric || null;
    this.isHQUser = this._hqService.isHqUser();  
    this.isClientCouponEnabled = this.isHQUser ? this._util.getIsClientCouponHq() : this._util.getIsClientCouponRest();
  }

  ngOnInit() {
    this.translateService.get('EDIT_AMOUNT').subscribe((data: any) => {
      this.modalTexts = { ...data };
      this.tabsGroup = [
        { label: this.modalTexts.CLIENT_COUPON, value: 'client_coupon' },
        { label: this.modalTexts.PRESETS, value: 'presets' },
        { label: this.modalTexts.FLAT_CASH_DISCOUNT, value: 'flat' },
        { label: this.modalTexts.PERCENTAGE_DISCOUNT, value: 'percentage' },
      ];
      this.reasonPresets = [
        { label: this.modalTexts.CELEBRATIONS, value: 'celebrations' },
        {
          label: this.modalTexts.DISCOUNT_TO_STAFF,
          value: 'discount_to_staff',
        },
        { label: this.modalTexts.LOYAL_CUSTOMER, value: 'loyal_customer' },
        {
          label: this.modalTexts.ISSUE_WITH_FOOD,
          value: 'issue_with_food_service',
        },
        // { label: "Other Reason", value: "other_reason" },
      ];
    });
    if (((this.data || {}).source === 'pos-order' ||  this.data.source === 'order-details') && this.isPresetEnabled) {
      this.fetchAllPresetDiscounts();
      if (this.isClientCouponEnabled) {
        this.fetchClientCouponsList();
      }
    } else if (
      (this.data || {}).source === 'pos-order' &&
      !this.isPresetEnabled
    ) {
      this.currentTab = 'flat';
    } else this.currentTab = 'flat';

    if(this.isClientCouponEnabled){
       this.currentTab = 'client_coupon';
    }
    (this._lang.getCountry() === country.id.country) && this.setFixedTopUpDiscountPresets();
  }

initialiseProperty() {
  this.percentageDiscount = [
    { id: 1, name: '5% off', value: '5', type: 'discount' },
    { id: 2, name: '10% off', value: '10', type: 'discount' },
    { id: 3, name: '15% off', value: '15', type: 'discount' },
    { id: 4, name: '20% off', value: '20', type: 'discount' },
  ];
  this.flatDiscount = [
    { id: 1, name: `-${this.Currency} 5`, value: '5', type: 'flat' },
    { id: 2, name: `-${this.Currency} 10`, value: '10', type: 'flat' },
    { id: 3, name: `-${this.Currency} 15`, value: '15', type: 'flat' },
    { id: 4, name: `-${this.Currency} 20`, value: '20', type: 'flat' },
  ];
  this.flatTopup = [
    { id: 1, name: `+${this.Currency} 10`, value: '10', type: 'flat' },
    { id: 2, name: `+${this.Currency} 15`, value: '15', type: 'flat' },
    { id: 3, name: `+${this.Currency} 20`, value: '20', type: 'flat' },
    { id: 4, name: `+${this.Currency} 25`, value: '25', type: 'flat' },
  ];
}

  setFixedTopUpDiscountPresets(){
    this.flatDiscount = this.flatTopup = [
      { id: 1, name: `${this.Currency} 10.000`, value: '10000', type: 'fixed' },
      { id: 2, name: `${this.Currency} 25.000`, value: '25000', type: 'fixed' },
      { id: 3, name: `${this.Currency} 50.000`, value: '50000', type: 'fixed' },
      { id: 4, name: `${this.Currency} 100.000`, value: '100000', type: 'fixed' },
    ]
  }

  cancel_clicked() {
    this.dialogRef.close({ status: 0, data: null, message: 'closed' });
  }

  submit() {
    if(this.currentTab == 'client_coupon'){
        this.selectedAmount = this.clientCouponCode;
    }
    if (this.isSpecialPreset) {
      // Check if user details have not been set
      if (!this.isUserDetailsSet) {
        // Display an error message indicating user details need to be added
        this.messageService.showError('Please add user details first with NRIC number to apply special preset');
        
        // Close the dialog and return with a message to open the user form
        return this.dialogRef.close({
          message: 'open_user_form'
        });
      }
    
      // Check if the NRIC number is not present
      if (!this.nric) {
        // Display an error message indicating that no valid NRIC number was found
        return this.messageService.showError('No valid NRIC number found to apply special preset');
      }
    }

    if (this.selectedDiscount === 'custom_discount')
      this.selectedAmount = this.customDiscountValue;
    if (!this.selectedAmount) {
      this.messageService.showError(`${this.modalTexts.ENTER_DIS_VAL}`);
      return;
    } else {
      this.dialogRef.close({
        status: 1,
        data: {
          amount: ['flat','percentage'].includes(this.currentTab) ? +this.format.formatMy(this.selectedAmount) : this.selectedAmount,
          type: this.currentTab == 'client_coupon' ? 'presets': this.currentTab,
          reason:
            this.selectedReason !== 'other_reason'
              ? this.selectedReason
              : this.customReason,
          nric: this.nric
        },
        message: this.modalTexts.COUPON_ADD,
      });
    }
  }

  inputChanges(e) {
    console.log( this.currentTab === 'percentage' &&
    parseFloat(this.format.formatMy(this.customDiscountValue)) === 10 &&
    e.charCode > 43,this.format.formatMy(this.customDiscountValue))
    if (
      this.currentTab === 'percentage' &&
      parseFloat(this.format.formatMy(this.customDiscountValue)) > 10
    )
      return false;
    else if (
      this.currentTab === 'percentage' &&
      parseFloat(this.format.formatMy(this.customDiscountValue)) === 100 &&
      e.charCode > 43
    )
      return false;
    return e.charCode >= 44 && e.charCode <= 57 && e.charCode !== 47;
  }

  numBack(e) {
    this.customInput.nativeElement.value =
      this.customInput.nativeElement.value.substr(
        0,
        this.customInput.nativeElement.value.length - 1
      );
    this.customDiscountValue = this.customInput.nativeElement.value;
  }

  getNumber(number) {
    let temp = this.customInput.nativeElement.value;
    this.customInput.nativeElement.value += number;
    if (
      this.currentTab === 'percentage' &&
      parseFloat(this.customInput.nativeElement.value) > 100
    ) {
      this.customInput.nativeElement.value = temp;
    }
    this.customDiscountValue = this.customInput.nativeElement.value;
  }

  getDecimal(e) {
    if (!this.customInput.nativeElement.value.includes(e)) {
      this.customInput.nativeElement.value += e;
      this.customDiscountValue = this.customInput.nativeElement.value;
    }
  }

  changeTab(item) {
    this.currentTab = item;
    this.customDiscountValue = null;
    this.selectedReason = null;
    this.selectedDiscount = null;
    this.selectedAmount = null;
    this.customReason = '';
    this.searchFilter = '';
    this.filterOutClientCoupons();
    if (this.currentTab !== 'presets') {
      setTimeout(() => {
        this.customInput.nativeElement.value = '';
      }, 100);
    }
  }

  reasonClicked(reason) {
    this.selectedReason = reason.label;
  }

  discountClicked(item) {
    if (this.currentTab === 'presets') {
      this.selectedDiscount = item.code;
      this.selectedAmount = item.code;
      this.isSpecialPreset = item?.is_special_preset;
    } else {
      this.selectedDiscount = item.name;
      this.selectedAmount = item.value;
      this.isSpecialPreset = null;
    }
    if (this.selectedDiscount === 'custom_discount') {
      setTimeout(() => {
        this.customInput.nativeElement.focus();
      }, 100);
    }
  }

  fetchAllPresetDiscounts() {
    this.isLoading = true;
    const payload = {
      restaurant_id: localStorage.getItem('restaurant_id'),
      applied_for: 1,
    };
    this.apiService.getAllPresetCoupons(payload).subscribe(
      (response: any) => {
        this.isLoading = false;

        if (response.statusCode === 201) {
          this.allPresetCouponsList = response.data;
          this.filterOutClientCoupons();
        }
      },
      (error) => {
        this.isLoading = false;
        this.messageService.showError((error.error || {}).message);
      }
    );
  }

  fetchClientCouponsList() {
    const params = {
      clientCouponTypeArr: [],
      pageNo: 1,
      pageSize: 1000
    };
    if (!this.isHQUser) {
      params['restaurant_ids'] = [this._localStorage.get('restaurant_id')];
    } else {
      params['hq_id'] = this._localStorage.get('hq_id');
    }
    this.apiService.getClientCoupons(params).subscribe(
      (response) => {
        if (response?.statusCode == 201) {
          this.listOfClientCoupons = response?.data?.data || [];
          this.filterOutClientCoupons();
        } else {
          this.listOfClientCoupons = [];
          this.filterOutClientCoupons();
        }
      },
      (error) => {
        this.listOfClientCoupons = [];
        this.filterOutClientCoupons();
      }
    );
  }

  filterOutClientCoupons() {
    if (!this.isClientCouponEnabled || !this.listOfClientCoupons || this.listOfClientCoupons.length === 0) {
      this.presetCouponList = [...this.allPresetCouponsList];
      return;
    }
    const clientCouponCodes = new Set(this.listOfClientCoupons.map(coupon => coupon.code?.toLowerCase()));
    this.presetCouponList = this.allPresetCouponsList.filter(coupon => {
      return !clientCouponCodes.has(coupon.code?.toLowerCase());
    });
  }

  searchQueryChange(e) {
    // First filter out client coupons, then apply search filter
    let filteredList = this.allPresetCouponsList;
    if (this.isClientCouponEnabled && this.listOfClientCoupons && this.listOfClientCoupons.length > 0) {
      const clientCouponCodes = new Set(this.listOfClientCoupons.map(coupon => coupon.code?.toLowerCase()));
      filteredList = this.allPresetCouponsList.filter(coupon => {
        return !clientCouponCodes.has(coupon.code?.toLowerCase());
      });
    }
    this.presetCouponList = filteredList.filter(
      (item) =>
        (item.code || '')
          .toLowerCase()
          .indexOf((this.searchFilter || '').toLowerCase()) !== -1
    );
  }
}
